<template>
    <div class="product-filters__wrapper">
        <DropdownPanel additionalLabel="Filters" :isOpen="isFiltersOpen" :hideToggle="hideToggle" @toggle="handleToggle">
            <template v-slot:header-content>
                <div class="product-filters__bar">
                    <div class="product-filters__group">
                        <p class="num-products">{{ productCountLabel }}</p>
                    </div>
                    <SearchInput placeholderText="search within results" @handleSearch="handleSearch" ref="searchTerm" />
                </div>
            </template>

            <template v-slot:content>
                <div class="product-filters__form">
                    <div class="row">
	                    <template v-if="filters?.length">
		                    <div v-for="(filter, index) in filters" :key="index" class="product-filters__form col-sm-4 col-md-4 col-lg-4 pr-0 pl-0">
			                    <component :is="filter.displayType" v-bind="filter" :isSmallLabel="true" :showNumResults="true" :key="filter.slug" @filterChange="handleUpdateFilters" />
		                    </div>
	                    </template>
	                    <template v-else>
		                    <div class="mb-3 text-grey-med">No Filters Available</div>
	                    </template>
                    </div>
	                <div class="row">
		                <Cta type="link" size="lg" label="Reset" :fitInline="true" @onClick="handleReset" v-if="(activeFilters > 0 || searchQuery) || !filters?.length" />
	                </div>
                </div>
            </template>
        </DropdownPanel>
    </div>
</template>

<script>
import Cta from './shared/Cta.vue';
import DropdownPanel from './shared/DropdownPanel.vue';
import SearchInput from './shared/SearchInput.vue';
import Checkbox from './shared/Checkbox.vue'; // Adjust the path accordingly
import RadioGroup from './shared/RadioGroup.vue'; // Adjust the path accordingly
import Dropdown from './shared/Dropdown.vue';
import { mapActions } from 'vuex';
export default {
    name: 'ProductFilters',
    components: {
        SearchInput,
        DropdownPanel,
        Cta,
        Checkbox,
        RadioGroup,
        Dropdown,
    },
    props: {
        productCount: {
            type: Number,
            default: 0,
        },
        filters: {
            type: Array,
            default: [],
        },
    },
    computed: {
        ...mapActions(['updateProductFilters']),
        productType: function () {
            return this.$route.params?.product;
        },
        productCountLabel() {
            if (this.productCount === 1) {
                return this.productCount + ' Product';
            } else {
                return this.productCount + ' Products';
            }
        },
	    activeFilters() {
			return this.filters?.reduce((acc, item) => {
				return acc + item?.filterValues.filter(value => value?.isSelected).length || 0;
			}, 0);
	    }
    },
    data() {
        return {
            hideToggle: this.filters?.length === 0 ? true : false,
            selectedFilters: [],
            searchQuery: '',
            isFiltersOpen: false,
        };
    },
    methods: {
        async handleUpdateFilters(filterData) {
            let selected = filterData.filterValues.filter((filterItem) => filterItem.isSelected).map((filterItem) => filterItem.title);
            this.selectedFilters = selected;

            await this.$store.dispatch('updateProductFilters', { productType: this.productType, ...filterData, searchTerm: this.searchQuery });
            // this.$emit('update-filters', { ...filterData, searchTerm: this.searchQuery });
        },
        formatFilters(filterArray) {
            return filterArray.map((FilterCategory) => {
                return { name: FilterCategory.slug, values: FilterCategory.filterValues.filter((filterItem) => filterItem.isSelected).map((filterItem) => filterItem.title) };
            });
        },
        async handleReset() {
            this.$refs.searchTerm.clearSearch();
            this.selectedFilters = [];

            this.searchQuery = '';
            let filtersCopy = JSON.parse(JSON.stringify(this.filters));
            await this.$store.dispatch('updateProductFilters', { productType: this.productType, filters: [...filtersCopy], searchTerm: '', updateMany: true, reset: true });

            //emit updatedFilters to parent with empty filter object, empty search string and it should return you new updated filters
        },
        async handleSearch(searchString) {
            let filtersCopy = JSON.parse(JSON.stringify(this.filters));
            this.searchQuery = searchString;

            await this.$store.dispatch('updateProductFilters', { productType: this.productType, filters: [...filtersCopy], searchTerm: searchString, updateMany: true });
        },
        handleToggle(isDropdownPanelOpen) {
            this.isFiltersOpen = isDropdownPanelOpen;
        },
    },
};
</script>
